import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/store";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState({}, document.title, "/profile");
        navigate("/profile");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return <div className="flex h-screen items-center justify-center text-gray-400" data-testid="auth-callback">Signing you in…</div>;
}
